import React, { useEffect, useState, useMemo } from "react";
import Orders from "./OrdersTableItem";
import { useDispatch, useSelector } from "react-redux";
import CustomerDetailModal from "../../components/CustomerDetailModal.jsx";
import CanView from "@/components/CanView.jsx";
import moment from "moment";

function OrdersTable({ handleOpenOrder, isSmallSize }) {
  const { activeOrders } = useSelector((state) => state.orders);

 
  const dispatch = useDispatch();
  const [customerModalOpen, setCustomerModalOpen] = useState(false);
  const [selectedCustomerEmail, setSelectedCustomerEmail] = useState(null);
  const [currentTime, setCurrentTime] = useState(moment());

  // const tutorialOrder = useSelector((state) => state.orders.tutorialOrders);
  const tutorialOrder = [];

  const handleOpenCustomerModal = (customerEmail) => {
    setSelectedCustomerEmail(customerEmail);
    setCustomerModalOpen(true);
  };

  // Separate orders into active and scheduled (>2 hours away)
  const { activeOrdersList, scheduledOrdersList } = useMemo(() => {
    const allOrders = [...tutorialOrder, ...activeOrders];
    const active = [];
    const scheduled = [];

    allOrders.forEach((order) => {
      if (order.scheduled) {
        const hoursUntilScheduled = moment(order.scheduled).diff(currentTime, "hours", true);
        if (hoursUntilScheduled > 2) {
          scheduled.push(order);
        } else {
          active.push(order);
        }
      } else {
        active.push(order);
      }
    });

    return { activeOrdersList: active, scheduledOrdersList: scheduled };
  }, [activeOrders, tutorialOrder, currentTime]);

  // Update current time every minute to re-evaluate which orders should be in which section
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment());
    }, 60000); // Update every minute

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // dispatch //RESET_UNSEEN_ORDER_COUNT
    dispatch({ type: "RESET_UNSEEN_ORDER_COUNT" });
  }, []);

  const allOrdersCount = activeOrdersList.length + scheduledOrdersList.length;

  if (allOrdersCount === 0) {
    return (
      <div className="bg-white dark:bg-theme-surface-accent shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 relative overflow-x-auto">
        <div className="text-center p-4 text-slate-500 dark:text-slate-400">
          No active orders
        </div>
      </div>
    );
  }

  const renderTableHeader = () => {
    if (isSmallSize) return null;
    return (
      <thead className="text-xs uppercase text-slate-500 dark:text-slate-400 bg-slate-50 dark:bg-slate-900/20 border-t border-slate-200 dark:border-slate-700">
        <tr>
          <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
            <div className="font-semibold text-left">Order</div>
          </th>
          <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
            <div className="font-semibold text-left">Date</div>
          </th>
          <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
            <div className="font-semibold text-left">Customer</div>
          </th>
          <CanView directOnly>
            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
              <div className="font-semibold text-left">Type</div>
            </th>
          </CanView>
          <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
            <div className="font-semibold text-left">Items</div>
          </th>
          <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
            <div className="font-semibold text-left">Status</div>
          </th>
          <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
            <div className="font-semibold text-left">Total</div>
          </th>
          <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
            <div className="font-semibold text-left">View</div>
          </th>
        </tr>
      </thead>
    );
  };

  return (
    <div className="bg-white dark:bg-theme-surface-accent shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 relative">
      <div className="overflow-x-auto">
        {/* Table */}
        <table className="table-auto w-full dark:text-slate-300 divide-y divide-slate-200 dark:divide-slate-700">
          {/* Table header */}
          {renderTableHeader()}
            {/* Active Orders Section */}
            {activeOrdersList.length > 0 && (
              <>
                {activeOrdersList.map((order) => {
                  return (
                    <Orders
                      isSmallSize={isSmallSize}
                      key={order._id}
                      order={order}
                      handleOpenOrder={handleOpenOrder}
                      onOpenCustomerModal={handleOpenCustomerModal}
                    />
                  );
                })}
              </>
            )}
            {/* Scheduled Orders Section (more than 2 hours away) */}
            {scheduledOrdersList.length > 0 && (
              <>
                <tbody>
                  <tr>
                    <td 
                      colSpan={8} 
                      className="px-2 first:pl-5 last:pr-5 pt-4 pb-2 bg-slate-50 dark:bg-slate-800/30 border-t border-slate-200 dark:border-slate-700"
                    >
                      <div className="text-xs uppercase font-semibold text-slate-500 dark:text-slate-400 tracking-wide">
                        Scheduled Orders (More than 2 hours away)
                      </div>
                    </td>
                  </tr>
                </tbody>
                {scheduledOrdersList.map((order) => {
                  return (
                    <Orders
                      isSmallSize={isSmallSize}
                      key={order._id}
                      order={order}
                      handleOpenOrder={handleOpenOrder}
                      onOpenCustomerModal={handleOpenCustomerModal}
                    />
                  );
                })}
              </>
            )}
        </table>
      </div>

      {/* Customer Detail Modal */}
      <CustomerDetailModal
        modalOpen={customerModalOpen}
        setModalOpen={setCustomerModalOpen}
        customerEmail={selectedCustomerEmail}
        title="Customer Profile"
      />
    </div>
  );
}

export default OrdersTable;
